import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 6.56485H6.75L8.1135 3.1561C8.22751 2.87134 8.28209 2.56627 8.2739 2.25964C8.26569 1.95301 8.19489 1.6513 8.06582 1.37304C7.93675 1.09478 7.75215 0.845845 7.52336 0.641536C7.29456 0.437228 7.02641 0.281858 6.73537 0.184973L6.35287 0.0578479C6.13825 -0.0138499 5.90697 -0.0190215 5.68935 0.0430113C5.47173 0.105044 5.27794 0.231386 5.13338 0.405473L0.259875 6.2521C0.0918372 6.45439 -0.000102341 6.70912 8.54899e-08 6.9721V18.9398C8.54899e-08 19.5366 0.237053 20.1089 0.65901 20.5308C1.08097 20.9528 1.65326 21.1898 2.25 21.1898H10.3612C10.9148 21.1896 11.4488 20.9854 11.8612 20.6162C12.2736 20.2469 12.5355 19.7386 12.5966 19.1885L13.5 11.0648H20.25C20.8467 11.0648 21.419 10.8278 21.841 10.4058C22.2629 9.98388 22.5 9.41158 22.5 8.81485C22.5 8.21811 22.2629 7.64581 21.841 7.22386C21.419 6.8019 20.8467 6.56485 20.25 6.56485Z"
      fill="#81BC00"
    />
  </svg>,
  "LearnMoreIcon"
);
